import { api } from '@/lib/api'
import type { User } from '@/types'
import { useEffect, useState } from 'react'

export function useUsers() {
    const [users, setUsers] = useState<User[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                setLoading(true)
                const data = await api.getAllUsers()
                setUsers(data)
            } catch (err) {
                setError(err instanceof Error ? err.message : 'Failed to fetch users')
            } finally {
                setLoading(false)
            }
        }

        fetchUsers()
    }, [])

    const createUser = async (user: User) => {
        try {
            await api.createUser(user)
            const data = await api.getAllUsers()
            setUsers(data)
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to create user')
            throw err
        }
    }

    return { users, loading, error, createUser }
} 